import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { HttpService } from '../../services/http.service';
import { ConfigService } from '../../services/env-config.service';
import { concatMap, firstValueFrom, of, tap, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';

interface ConfigEnv {
  companyId: string;
  url: string;
  baseUrl: string;
  hostname: string;
}

const getCookie = (name: string): any => {
  const cookies = document.cookie.split('; ');
  const cookie = cookies?.find((row) => row.startsWith(name + '='));
  return cookie ? cookie.split('=')[1] : null;
};

const isValidBase64 = (str: string): any => {
  const fixedBase64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const decodedString = atob(fixedBase64);
  const cleanedString = decodedString.replace(/[\x00-\x1F\x7F]/g, '');
  return JSON.parse(cleanedString);
};

const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export function initializeApp(http: HttpService, dataService: DataService, config: ConfigService, router: Router, authService: AuthService) {
  return () => {
    // Process URL parameters
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const cookie = getCookie('mobileToken');

    const isMobileView = getCookie('mobileView');
    if (isMobileView) {
      localStorage.setItem('OnMobile', 'true');
      deleteCookie('mobileView');
    }

    const observable = config.getConfig().pipe(
      tap((data: ConfigEnv) => {
        if (!!data) {
          environment.url = data.url;
          environment.baseUrl = data.baseUrl;
          environment.hostname = window.location.hostname; //data.hostname;
        }
        config.baseUrl = environment.baseUrl;
      }),
      switchMap((data: ConfigEnv) => {
        if (!!data) {
          let callHttp = http.getCompanyConfiguration();
          const isPreviewMode = window.location.pathname.startsWith('/preview-page');
          if (isPreviewMode) {
            const bpCode = window.location.pathname.split('/').pop() ?? "";
            callHttp = http.getCompanyConfigurationPreview(bpCode);
          }
          return callHttp.pipe(
            tap((company) => {
              environment.contentful = company.contentful;
              environment.cookieDomainScript = company.cookieDomainScript;
              const companyConfig = company.companyCustomizations;
              dataService.setCompanyId(companyConfig.companyId);
              dataService.setActivationCode(company.hasCodeActivation);
              dataService.setURLS(company);
              dataService.setConfig({
                colors: companyConfig.colors,
                logos: companyConfig.logos,
                googleAppId: company.googleAppId,
                showGoogleLoginButton: company.showGoogleLoginButton,
                facebookAppId: company.facebookAppId,
                companyId: companyConfig.companyId,
                disabledMFA: company.disabledMFA,
                ssoUrl: company.ssoUrl,
                ssoRealm: company.ssoRealm,
                ssoClientId: company.ssoClientId 
              });  
            }),
            switchMap((company) => {
              if (cookie) {
                localStorage.setItem('OnMobile', 'true');
                const cookieEncoded = isValidBase64(cookie);
                localStorage.setItem('authToken', JSON.stringify(cookieEncoded.token));
                localStorage.setItem('userData', JSON.stringify(cookieEncoded));
                deleteCookie('mobileToken');
                return of(null);
              }

              if (code !== null) {
                const companyId = company.companyCustomizations.companyId;
                return http.getExternalUserIdByCode(code, companyId).pipe(
                  concatMap((externalUserId) => {
                    if (externalUserId) {
                      return http.getAuthToken(externalUserId, companyId).pipe(
                        concatMap((res) => {
                          if (res) {
                            return http.getUserData(res.auth_token, res.ea_individual_id).pipe(
                              tap((userData) => {
                                if (userData) {
                                  authService.checkLoginStatus(userData);
                                }
                              })
                            );
                          }
                          return of(null);
                        })
                      );
                    }
                    return of(null);
                  })
                );
              } else {
                console.log('Il parametro non esiste.');
                return of(null);
              }
            })
          );
        }
        return of(null);
      })
    );

    return firstValueFrom(observable);
  };
}
